import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { contactInfo } from '../../data/mock';

export const ContactInfoGrid = () => (
  <div className="valuare-contact-grid" data-testid="contact-info-grid">
    <div className="valuare-contact-card">
      <Phone className="valuare-contact-icon" />
      <h4>Telefone / WhatsApp</h4>
      <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
    </div>
    <div className="valuare-contact-card">
      <Mail className="valuare-contact-icon" />
      <h4>Email Geral</h4>
      <a href={`mailto:${contactInfo.emails.general}`}>{contactInfo.emails.general}</a>
    </div>
    <div className="valuare-contact-card">
      <Mail className="valuare-contact-icon" />
      <h4>Perito Avaliador</h4>
      <a href={`mailto:${contactInfo.emails.admin}`}>{contactInfo.emails.admin}</a>
    </div>
    <div className="valuare-contact-card">
      <MapPin className="valuare-contact-icon" />
      <h4>Área de Atuação</h4>
      <span>{contactInfo.coverage}</span>
    </div>
  </div>
);
